import React from 'react'

export default function SignupClient() {
  const onSubmit = (e) => { e.preventDefault(); alert('Create client account (implement)') }
  return (
    <div style={{maxWidth:720, margin:'0 auto'}}>
      <section className="card">
        <h2 className="h2">Create Client Account</h2>
        <form onSubmit={onSubmit} style={{display:'grid', gap:12, marginTop:12}}>
          <input className="input" placeholder="Full name" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" type="email" placeholder="Email" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" type="tel" placeholder="Phone (optional)" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <input className="input" type="password" placeholder="Create password" required style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}/>
          <button className="btn primary" type="submit">Create account</button>
        </form>
      </section>
    </div>
  )
}
